export type IframeScenario = 'BizChatSidebar' | 'HelpPane';

export type ScenarioSettings = {
    matchUrl: (url: string) => boolean;
    enablePreloading: boolean;
    enableCaching: boolean;
};

const defaultSettings: Omit<ScenarioSettings, 'matchUrl'> = {
    enablePreloading: false,
    enableCaching: false,
};

export const iframesMapping: Record<IframeScenario, ScenarioSettings> = {
    BizChatSidebar: {
        ...defaultSettings,
        matchUrl: (url: string) =>
            url.includes('/hosted/semanticoverview/') ||
            url.includes('m365copilotapp.svc.cloud.microsoft/chat'),
        enablePreloading: true,
        enableCaching: true,
    },
    HelpPane: {
        ...defaultSettings,
        matchUrl: (url: string) => url.includes('https://cjs.diagnostics.office.com/support'),
    },
};
